import React from "react";
import styles from "./ErrorBoundary.module.scss";
import { MANAGER_URL } from "../../config";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    setTimeout(() => { window.location.reload(); }, 50);
  };

  handleManager = () => {
    const tg = window.Telegram?.WebApp;
    if (tg?.openTelegramLink) tg.openTelegramLink(MANAGER_URL);
    else window.open(MANAGER_URL, "_blank", "noopener,noreferrer");
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className={styles.wrap}>
        <div className={styles.card}>
          <div className={styles.iconWrap}>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" aria-hidden>
              <defs>
                <linearGradient id="errGrad" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stopColor="#a78bfa"/>
                  <stop offset="1" stopColor="#c084fc"/>
                </linearGradient>
              </defs>
              <circle cx="32" cy="32" r="28" stroke="url(#errGrad)" strokeWidth="2" fill="rgba(124,83,255,0.12)"/>
              <rect x="30" y="16" width="4" height="22" rx="2" fill="url(#errGrad)"/>
              <circle cx="32" cy="46" r="2.4" fill="url(#errGrad)"/>
            </svg>
          </div>
          <h1 className={styles.title}>Что-то пошло не так</h1>
          <p className={styles.text}>
            Попробуйте обновить страницу.<br />
            Если не помогает, напишите менеджеру.
          </p>
          <div className={styles.actions}>
            <button type="button" className={styles.primary} onClick={this.handleRetry}>
              Обновить
            </button>
            <button type="button" className={styles.secondary} onClick={this.handleManager}>
              Менеджер
            </button>
          </div>
          {this.state.error?.message && (
            <details className={styles.details}>
              <summary>Подробности</summary>
              <code>{this.state.error.message}</code>
            </details>
          )}
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
